import React from "react";
import { Link } from "react-router-dom";
import { CONTACT_EMAIL } from "./offers";

const styles = `
  .sf-footer { border-top: 1px solid var(--rule, #ddd8cf); background: var(--paper-warm, #f2ede4); padding: 28px 32px; text-align: center; }
  .sf-footer p { font-size: 12px; color: var(--ink-faint, #b8b2aa); font-family: var(--sans, system-ui, sans-serif);
    display: flex; flex-wrap: wrap; justify-content: center; align-items: baseline; row-gap: 6px; }
  .sf-footer a, .di-root .sf-footer a { color: var(--ink-muted, #5a5650); text-decoration: none; }
  .sf-footer strong { margin-right: 4px; }
  .sf-footer a:hover { text-decoration: underline; }
  .sf-sep { margin: 0 10px; }
`;

export default function SiteFooter() {
  return (
    <>
      <style>{styles}</style>
      <footer className="sf-footer">
        <p>
          <strong style={{ color: "var(--ink-muted, #5a5650)" }}>Documore LLC</strong> — © {new Date().getFullYear()}
          <span className="sf-sep">·</span>
          <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
          <span className="sf-sep">·</span>
          <Link to="/services">Capabilities</Link>
          <span className="sf-sep">·</span>
          <Link to="/about">About</Link>
          <span className="sf-sep">·</span>
          <Link to="/privacy">Privacy</Link>
        </p>
      </footer>
    </>
  );
}
